var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content",
    style: _vm.colors
  }, [_c('div', {
    staticClass: "custom-elanco-header"
  }, [_c('span', {
    staticClass: "custom-elanco-header__text"
  }, [_vm._v("Hi " + _vm._s(_vm.deepGet(_vm.user, 'name')))]), _c('a', {
    attrs: {
      "href": _vm.deepGet(_vm.event, 'config.header_logo_url', '#')
    }
  }, [_vm.deepGet(_vm.event, 'config.images.header_logo') ? _c('img', {
    staticClass: "custom-elanco-header__image ml-3",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.header_logo')
    }
  }) : _vm._e()])]), _vm.page === 'redeem' ? _c('div', [_vm.deepGet(_vm.event, 'config.images.redeem_confirm_kv') ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.redeem_confirm_kv'),
      "alt": "Elanco"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-3 px-4"
  }, [_vm.isRedeemSuccess ? _c('div', {
    staticClass: "redeem-success-message mb-3"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.event, 'config.universal_code_success_message', '兌換成功')) + " ")]) : _vm._e(), _vm.deepGet(_vm.event, 'config.redeem_notes_top') ? _c('div', {
    staticClass: "redeem-notes redeem-notes--top mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.event, 'config.redeem_notes_top'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "card__info"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.branchCode,
      expression: "branchCode"
    }],
    staticClass: "form-control-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.deepGet(_vm.event, 'config.branch_placeholder', '請輸入認證碼'),
      "disabled": _vm.isRedeemSuccess
    },
    domProps: {
      "value": _vm.branchCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.branchCode = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "card__info"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.packageName,
      expression: "packageName"
    }],
    staticClass: "form-control-input",
    attrs: {
      "disabled": _vm.isRedeemSuccess
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.packageName = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("請選擇組數")]), _vm._l(_vm.deepGet(_vm.event, 'config.redeem_package', []), function (pkg) {
    return _c('option', {
      key: pkg.value,
      domProps: {
        "value": pkg.value
      }
    }, [_vm._v(_vm._s(pkg.text))]);
  })], 2)]), _vm.deepGet(_vm.event, 'config.redeem_notes_bottom') ? _c('div', {
    staticClass: "redeem-notes redeem-notes--bottom mt-3",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.event, 'config.redeem_notes_bottom'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "btn-container"
  }, [_c('button', {
    staticClass: "s-btn s-btn-xs redeem-submit-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading || !_vm.branchCode || _vm.isRedeemSuccess || !_vm.packageName
    },
    on: {
      "click": _vm.redeem
    }
  }, [_vm._v(" 確定送出 ")]), _vm._l(_vm.buttons, function (button) {
    return _c('a', {
      key: button.order,
      staticClass: "s-btn s-btn-xs mt-3 d-block text-center",
      style: {
        backgroundColor: button.button_bg_color,
        color: button.button_text_color
      },
      attrs: {
        "href": button.button_url
      }
    }, [_vm._v(" " + _vm._s(button.button_text) + " ")]);
  })], 2)])]) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "modal-universal-code",
      "centered": "",
      "hide-header": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "footer-class": 'universal-code-modal__footer'
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('button', {
          staticClass: "s-btn s-btn-xs universal-code-modal__btn-cancel",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.closeUniversalCodeModal
          }
        }, [_vm._v(" 取消 ")]), _c('button', {
          staticClass: "s-btn s-btn-xs universal-code-modal__btn-submit",
          attrs: {
            "type": "button",
            "disabled": _vm.isLoading || !_vm.universalCode
          },
          on: {
            "click": _vm.redeemByUniversalCode
          }
        }, [_vm._v(" 送出 ")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "universal-code-modal__body"
  }, [_vm.deepGet(_vm.event, 'config.universal_code_title') ? _c('div', {
    staticClass: "universal-code-modal__title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.event, 'config.universal_code_title')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "universal-code-modal__field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.universalCode,
      expression: "universalCode"
    }],
    staticClass: "form-control-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.deepGet(_vm.event, 'config.universal_code_placeholder', '請輸入萬用優惠碼')
    },
    domProps: {
      "value": _vm.universalCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.universalCode = $event.target.value;
      }
    }
  })]), _vm.deepGet(_vm.event, 'config.clinic_title') ? _c('div', {
    staticClass: "universal-code-modal__field"
  }, [_c('div', {
    staticClass: "universal-code-modal__clinic-title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.event, 'config.clinic_title')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.clinic,
      expression: "clinic"
    }],
    staticClass: "form-control-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.deepGet(_vm.event, 'config.clinic_title_placeholder', '')
    },
    domProps: {
      "value": _vm.clinic
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.clinic = $event.target.value;
      }
    }
  })]) : _vm._e()])]), _vm.page === 'empty_message' ? _c('div', [_vm._m(0), _c('div', {
    staticClass: "btn-container"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" 返回上一頁 ")])])]) : _vm._e()], 1)])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "alert-message"
  }, [_vm._v(" 網址錯誤，沒有活動代碼 ")])]);
}]

export { render, staticRenderFns }